import React from 'react'

import { BrandedAlertModal } from 'components/Modal'
import type { BrandedAction } from 'components/Modal/BrandedAlertModal/BrandedAlertModal'

interface WithdrawActionsProps {
  isOpen: boolean
  onApplicationWithdraw: () => void
  onCancel: () => void
}

// T2-6161: the "Withdraw Application" confirmation now uses the shared
// BrandedAlertModal so it matches the TempStars design system (header bar,
// rounded card, horizontal Cancel / primary action footer) instead of the old
// stacked legacy popup buttons.
const WithdrawActions = ({
  isOpen,
  onApplicationWithdraw,
  onCancel,
}: WithdrawActionsProps) => {
  const actions: BrandedAction[] = [
    { label: 'Cancel', variant: 'secondary', onClick: onCancel },
    { label: 'Withdraw My Application', variant: 'primary', onClick: onApplicationWithdraw },
  ]

  return (
    <BrandedAlertModal
      isOpen={isOpen}
      onClose={onCancel}
      title="Withdraw Application"
      ariaLabel="Withdraw Application"
      actions={actions}
    >
      Are you sure you would like to withdraw your application to this job? This employer will no longer be able to view your resume for this job.
    </BrandedAlertModal>
  )
}

export default WithdrawActions;
